import axios from "axios";
import AllRoutes from "../../nametitle/AllRoutes";
import { baseUrl } from "../../nametitle/dataUrl";
import { lastDayOfQuarterWithOptions } from "date-fns/fp";


// Créer un Don
export const CreateDon = (title, coverPicture, description, date,video, redirect) => {
  var data = JSON.stringify({
    "title": title,
    "coverPicture": coverPicture,
    "description": description,
    "date":date,
    "video": video,
  });
  var config = {
    method: 'post',
    url: `${baseUrl.baseUrl}/api/v1/activites/dons/`,
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      // console.log(JSON.stringify(response.data));
      redirect(`/${AllRoutes.admin}/${AllRoutes.activity}#dons`);
      window.location.reload();
    })
    .catch(function (error) {
      // console.log(error);
      alert("Done add failed")
    });
}

// Mise ajour du Témoignage
export const UpdateDon = (id, title, coverPicture, description,date, video,visible, redirect) => {
  var data = JSON.stringify({
    "title": title,
    "coverPicture": coverPicture,
    "description": description,
    "date":date,
    "video": video,
    "visible":visible
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/activites/dons/${id}`,
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      // console.log(JSON.stringify(response.data));
      window.location.reload();
      // redirect(`/${AllRoutes.admin}/${AllRoutes.activity}#dons`);
      
    })
    .catch(function (error) {
      // console.log(error);
      alert("Update failed")
    });
}









// Recupérer tout les programes
export const LoadAllDon = (SetState) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/activites/dons/get/all`, {
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    }
  })
    .then(function (response) {
      // console.log(JSON.stringify(response.data));
      SetState(response.data.data)
    })
    .catch(function (error) {
      // console.log(error);
    });
}

// Recupérer tout les programes
export const LoadAllDonVisible = (SetState) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/activites/dons/visible/`, {
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    }
  })
    .then(function (response) {
      // console.log(JSON.stringify(response.data));
      SetState(response.data.data)
    })
    .catch(function (error) {
      // console.log(error);
      alert("failed")
    });
}


